import { QueryClient } from "@tanstack/react-query";
import { isRetryable } from "./errors";

/** Shared defaults: short stale time, retries only for transient failures, never for mutations. */
export function createQueryClient(): QueryClient {
	return new QueryClient({
		defaultOptions: {
			queries: {
				staleTime: 30_000,
				retry: (failures, error) => failures < 3 && isRetryable(error),
				refetchOnWindowFocus: true,
			},
			mutations: {
				retry: false,
			},
		},
	});
}
